import * as React from 'react';

export const LazyRTOExperienceQuestion = React.lazy(() => import('./component'));
